function encodedPath(segments: readonly string[]): string {
  return segments.map((segment) => encodeURIComponent(segment)).join('/');
}

export function cloudWorkspaceFileUrl(taskId: string, path: string): string {
  return `/api/cloud/tasks/${encodeURIComponent(taskId)}/workspace/${encodedPath(path.split('/'))}`;
}
